import React from 'react';
import {ReactComponent as Hand} from 'images/icon/hand-point-right.svg';
import './LongTermCoachingBanner.styl';

export default class LongTermCoachingBanner extends React.PureComponent {
  render() {
    const {noRecommendations, hideSuggested} = this.props;

    return (
      <div className="long-term-coaching-banner">
        <h3>Set Up A Long-term Coaching Plan</h3>
        <div className="content">
          <div className="cta">
            Your recent coaching meetings have all used live coaching or "Coach Now".
            {!noRecommendations && !hideSuggested ? (
              <p>
                Click one of the recommendations on the right to try a longer term coaching plan.
                <div className="hand-wrapper">
                  <Hand />
                </div>
              </p>
            ) : (
              <p>
                Consider setting up a long term plan with your reps who show motivation to improve.
              </p>
            )}
          </div>
        </div>
      </div>
    );
  }
}
